import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ShareProfileService } from '@cpd-app/core-module/services';

@Component({
  templateUrl: './return-session-banner.component.html',
  styleUrls: ['./return-session-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule],
  standalone: true
})
export class ReturnSessionBannerComponent {
  protected readonly returnSessionBannerTitle = computed(() =>
    this.shareProfileService.bannerTitle()
  );

  constructor(
    private readonly snackBarRef: MatSnackBarRef<ReturnSessionBannerComponent>,
    private readonly shareProfileService: ShareProfileService
  ) {}

  protected close(): void {
    this.snackBarRef.dismiss();
  }
}
